import React, { useState } from 'react';

const DISMISSED_KEY = 'feedback-banner-dismissed-questions-v1';

export const FeedbackBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISSED_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISSED_KEY, '1'); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-5 py-2.5 flex items-start gap-3 shrink-0 text-xs text-amber-800">
      <span className="shrink-0 mt-0.5">⚠</span>
      <span className="flex-1">
        <strong>Feedback is stored in your browser</strong> and keyed by question number (csv_id),
        so it survives database reseeds. It will be lost if you clear your browser storage.
        Export before sharing with a developer.
      </span>
      <button onClick={dismiss} className="shrink-0 text-amber-500 hover:text-amber-700 font-medium leading-none mt-0.5">
        Got it
      </button>
    </div>
  );
};
